// src/components/TermsAndConditions.js
import React from 'react';

const TermsAndConditions = () => {
  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
      <h1>Terms and Conditions</h1>

      <p>Last updated: {new Date().toLocaleDateString()}</p>

      <p>
        Welcome to ThatPuzzleApp.com and Puzzle of the Day, provided by Psquared Creations LLC,
        located at 10437 Jacob Place, Littleton, CO 80125. By accessing or using our free
        application, you agree to be bound by the following terms.
      </p>

      <h2>1. Ownership and Intellectual Property</h2>
      <p>
        All content, trademarks, and intellectual property on this site are owned by Psquared Creations LLC, Littleton, CO, 80125,
        unless otherwise stated. You may not copy, reuse, or distribute content without permission. 
      <h3>Exceptions</h3>  
        <ol>
          <li>Photos that you have created and share as part of a puzzle are your property. Psquared Creations LLC does not share user
            generated images without expressed permission from the poster. If you would like us to use one of your photos in our "puzzle of the Day"
            application, please email your image to psquaredcreationsllc@gmail.com with the Subject Line: "My Puzzle of the Day". We will review your image 
            and respond if your image is chosen as a Puzzle of the Day. 
          </li>
          <li>We strongly encourage users to uncheck the public image box if the want to protect their images from theft. By unchecking the public
            image check box, the completed image puzzle and preview will include a watermark to discourage piracy.</li>
        </ol>
      </p>

      <h2>2. Acceptable Use</h2>
      <p>
        You agree not to upload, share, or transmit any content that is unlawful, offensive, or infringes
        on third-party rights. We reserve the right to remove any content at our discretion.
      </p>

      <h2>3. User-Generated Content</h2>
      <p>
        You are solely responsible for the images and messages submitted to create puzzle gifts. 
        Psquared Creations is not liable for any misuse or unauthorized use of third-party content.
      </p>

      <h2>4. Privacy and Data Use</h2>
      <p>
        Your data is used only to generate and deliver puzzle links and optional email notifications.
        We do not sell your data. See our Privacy Policy for details.
      </p>

      <h2>5. Limitation of Liability</h2>
      <p>
        Psquared Creations is not responsible for any damages arising from use or inability to use
        this application, including but not limited to data loss or service interruption.
      </p>

      <h2>6. Updates to Terms</h2>
      <p>
        These terms may be updated at any time. Continued use of the app constitutes acceptance of
        the updated terms.
      </p>

      <h2>7. Contact</h2>
      <p>
        For questions or support, please contact us at <a href="mailto:support@thatpuzzleapp.com">support@thatpuzzleapp.com</a>.
      </p>
    </div>
  );
};

export default TermsAndConditions;
